// extracted by mini-css-extract-plugin
export var figcaption = "MediaWrapper-module--figcaption--4c4f7";
export var imgWrapper = "MediaWrapper-module--imgWrapper--97099";
export var multiImgFlex = "MediaWrapper-module--multiImgFlex--a6b99";
export var portraitImg = "MediaWrapper-module--portraitImg--8cfc8";